import UserProfile from '../../features/user-profile/components/UserProfile';
import useIsMobileView from '../../hooks/useIsMobileView';
import LobbyDesktopDisplay from './views/LobbyDesktopDisplay';
import LobbyMobileDisplay from './views/LobbyMobileDisplay';
import UserProfileMobile from '../../features/user-profile/components/UserProfileMobile';
import Header from '../../components/header/Header';
import { useAccountAbstractionInitialization } from '@/features/account-abstraction/hooks/useAccountAbstractionInitialization';
import { LobbyFiltersContextProvider } from './components/LobbyFiltersContext';
import React, { useRef } from 'react';
import DoubleLoginModal from '@/components/DoubleLoginModal/DoubleLoginModal';
import BREAKPOINTS from '@/common/constant/breakpoints';
// import BREAKPOINTS from "@/common/constant/breakpoints";
const Lobby = () => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const isMobileView = useIsMobileView({ checkForUserAgent: false, breakpoint: BREAKPOINTS.xl });
  useAccountAbstractionInitialization();
  // useRootFontSize(wrapperRef, {override: true});

  return (
    <LobbyFiltersContextProvider>
      <DoubleLoginModal />
      {isMobileView ? (
        <div ref={wrapperRef} className="text-[16px]">
          <Header />
          <div className="h-full p-4">
            <UserProfileMobile />
            <LobbyMobileDisplay />
          </div>
        </div>
      ) : (
        <div ref={wrapperRef} className="text-[16px]">
          <Header />
          <div className="flex h-full w-full gap-5 px-10 pt-5">
            <LobbyDesktopDisplay />
            <UserProfile />
          </div>
        </div>
      )}
    </LobbyFiltersContextProvider>
  );
};

export default Lobby;
